import { FilterChip } from './FilterChip'
import { FilterChipGroupProps } from '../types'

export function FilterChipGroup({ items, label, filterType, onRemoveFilter }: FilterChipGroupProps) {
  if (items.length === 0) return null

  return (
    <>
      <div className="h-4 w-px bg-gray-300 flex-shrink-0" />
      <span className="text-xs text-gray-600 whitespace-nowrap">{label}:</span>
      {items.map((item) => (
        <FilterChip
          key={item.id}
          id={item.id}
          name={item.name}
          onRemove={() => onRemoveFilter(filterType, item.id)}
        />
      ))}
    </>
  )
}
